/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.CompanyResponsiblePersonConnection = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The CompanyResponsiblePersonConnection model module.
   * @module model/CompanyResponsiblePersonConnection
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>CompanyResponsiblePersonConnection</code>.
   * @alias module:model/CompanyResponsiblePersonConnection
   * @class
   */
  var exports = function() {
    var _this = this;









  };

  /**
   * Constructs a <code>CompanyResponsiblePersonConnection</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/CompanyResponsiblePersonConnection} obj Optional instance to populate.
   * @return {module:model/CompanyResponsiblePersonConnection} The populated <code>CompanyResponsiblePersonConnection</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Activity')) {
        obj['Activity'] = ApiClient.convertToType(data['Activity'], 'String');
      }
      if (data.hasOwnProperty('BusinessIdentifier')) {
        obj['BusinessIdentifier'] = ApiClient.convertToType(data['BusinessIdentifier'], 'String');
      }
      if (data.hasOwnProperty('CompanyName')) {
        obj['CompanyName'] = ApiClient.convertToType(data['CompanyName'], 'String');
      }
      if (data.hasOwnProperty('PaymentMethod')) {
        obj['PaymentMethod'] = ApiClient.convertToType(data['PaymentMethod'], 'String');
      }
      if (data.hasOwnProperty('PublicActivityCode')) {
        obj['PublicActivityCode'] = ApiClient.convertToType(data['PublicActivityCode'], 'String');
      }
      if (data.hasOwnProperty('PublicActivityDate')) {
        obj['PublicActivityDate'] = ApiClient.convertToType(data['PublicActivityDate'], 'Date');
      }
      if (data.hasOwnProperty('PublicActivitySum')) {
        obj['PublicActivitySum'] = ApiClient.convertToType(data['PublicActivitySum'], 'Integer');
      }
      if (data.hasOwnProperty('Role')) {
        obj['Role'] = ApiClient.convertToType(data['Role'], 'String');
      }
    }
    return obj;
  }

  /**
   * @member {String} Activity
   * @default ''
   */
  exports.prototype['Activity'] = '';
  /**
   * @member {String} BusinessIdentifier
   * @default ''
   */
  exports.prototype['BusinessIdentifier'] = '';
  /**
   * @member {String} CompanyName
   * @default ''
   */
  exports.prototype['CompanyName'] = '';
  /**
   * @member {String} PaymentMethod
   * @default ''
   */
  exports.prototype['PaymentMethod'] = '';
  /**
   * @member {String} PublicActivityCode
   * @default ''
   */
  exports.prototype['PublicActivityCode'] = '';
  /**
   * @member {Date} PublicActivityDate
   */
  exports.prototype['PublicActivityDate'] = undefined;
  /**
   * @member {Integer} PublicActivitySum
   * @default 0
   */
  exports.prototype['PublicActivitySum'] = 0;
  /**
   * @member {String} Role
   * @default ''
   */
  exports.prototype['Role'] = '';



  return exports;
}));


